import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DownloadingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"downloading"}/>
}
